import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { fetchUser } from '../actions';
import { selectUser } from '../selectors';
import { Input } from '../../../components/Input';
import { FormField } from '../../../components/FormFields';

const STATE = {};
/* eslint-disable react/prefer-stateless-function */
class WithUserComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {
    if (!this.props.user) this.props.fetch();
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.user && this.props.user_id !== prevProps.user_id) {
      this.props.fetch();
    }
  }

  render() {
    if (!this.props.user) return null;
    if (this.props.inputLabel)
      return (
        <FormField style={{ width: '100%' }}>
          <Input
            disabled
            style={{ width: '100%' }}
            value={`${this.props.user?.name ?? ''} ${this.props.user?.surname ?? ''}`}
          />
        </FormField>
      );

    if (this.props.label) {
      return <span>{`${this.props.user?.name ?? ''} ${this.props.user.surname ?? ''}`}</span>;
    }

    return this.props.children;
  }
}

WithUserComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    user: selectUser(ownProps.user_id),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    fetch() {
      if (!parseInt(ownProps.user_id, 10)) return;

      dispatch(fetchUser(ownProps.user_id, () => {}, { work: ownProps.user_id }));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const WithUser = compose(withConnect, withRouter)(WithUserComp);
